export default {
  ownOrders: [],
  ownOrder: {}
}